import { ContractType } from '@shared/enums/contract-type';

export class ContractStateModel {
  isLoadingPaperContract: boolean;
  isLoadingEmailSent: boolean;
  isLoadingSmsSent: boolean;
  smsExchange?: SmsMessage[];
  smsContractLines?: string[];
}

export class SmsMessage {
  text: string;
  customerPhoneNumber: string;
  date: Date;
  toUser: boolean;
  signedDate?: Date;
}

export class SmsContract {
  text: string;
  customerPhoneNumber: string;
  sentDate: Date;
}

export class ContractResponse {
  id?: string;
  contractType: ContractType;
  isSigned?: boolean;
  hasDocument?: boolean;
  smsContract?: SmsContract;
  signedDate?: Date;
}

export class ContractTypeData {
  contractType: ContractType;
  customerPhoneNumber: string;
}

export class GenerateSmsContractRequest {
  phoneNumber: string;
}
